import { IMessage, IMessageData } from 'core/interface/contact';
import ApiBase from '../base/apiBase';
import { ApiError } from '../base/types';

export class ContactService {
  private static apiBase = new ApiBase<IMessageData>();

  public static sendMessage = async (
    body: IMessage,
  ): Promise<IMessageData | ApiError> => {
    return await this.apiBase.postAsync('tenant/contact/', body);
  };
}
